import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  IconButton,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import CloseIcon from "@material-ui/icons/Close";
import NewsRequests from "services/news";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    marginBlock: "16px",
    color: theme.palette.grey[500],
  },
  input: {
    display: "none",
  },
  uploaderContainer: {
    width: "60%",
    minWidth: "200px",
    marginInline: "auto",
    marginBlock: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: theme.palette.grey[500],
    borderWidth: "2px",
    borderStyle: "dashed",
    borderRadius: "10px",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddBatchPointDialog({
  open,
  handleClose,
}) {
  const [currentFile, setCurrentFile] = useState(null);
  const [currentFileName, setCurrentFileName] = useState("");

  const dispatch = useDispatch();
  const classes = useStyles();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setCurrentFile(file);
      setCurrentFileName(file.name);
    }
  };
  const handleUploadAndClose = () => {
    if (currentFile) {
      dispatch(NewsRequests.addBatchPoints(currentFile));
      handleClose();
      setCurrentFile();
      setCurrentFileName("");
    }
  };

  const handleRemove = () => {
    setCurrentFile();
    setCurrentFileName("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          وارد کردن گروهی سکه ها
        </DialogContentText>
        <Typography className={classes.title}>
          برای آپلود فایل بر روی آیکون فایل کلیک کنید!
        </Typography>
        <Box className={classes.uploaderContainer}>
          <input
            accept=".csv"
            className={classes.input}
            onChange={handleFileChange}
            id="icon-button-file"
            type="file"
          />
          <label htmlFor="icon-button-file">
            {!currentFile && (
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <NoteAddIcon fontSize="large" />
              </IconButton>
            )}
          </label>
          {currentFile && (
            <>
              <IconButton
                color="secondary"
                aria-label="delete picture"
                component="span"
                onClick={handleRemove}
              >
                <CloseIcon />
              </IconButton>
              <Typography>{currentFileName}</Typography>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUploadAndClose} color="primary">
          تایید و آپلود
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
